import { useState, type FC } from 'react';
import type {
  ComponentsAndAccessoriesEntity,
  SpecificationsEntity,
} from '../../../../@types/gql/product-detail';
import OpacitySlideIn from '../../../animation/opacity-slide-in';
import ProductDetailComponentsAndAccessories from './components-and-accessories';
import ProductDetailSpecifications from './specifications';

const ProductDetailInfo: FC<{
  specification: { description: string; list: SpecificationsEntity[] };
  components: ComponentsAndAccessoriesEntity[];
}> = ({ specification, components }) => {
  const [view, setView] = useState<'specs' | 'comp'>('specs');

  return (
    <div className="container mx-auto px-6">
      <div className="flex items-center space-x-4 mb-4 pt-10 justify-center  max-md:justify-normal overflow-x-auto">
        <button
          className={`whitespace-nowrap py-3 px-4 font-medium bg-[#F1F1F1] max-xl:text-lg max-2xl:text-xl max-md:text-base rounded-md uppercase tracking-wide transition-smooth 
        ${view === 'specs' ? 'bg-action-btn text-white font-bold' : 'hover:bg-action-btn hover:text-white'}`}
          onClick={() => {
            setView('specs');
          }}
          type="button"
        >
          Specifications
        </button>

        <button
          className={`whitespace-nowrap py-3 px-4 font-medium bg-[#F1F1F1] max-xl:text-lg max-2xl:text-xl max-md:text-base rounded-md uppercase tracking-wide transition-smooth 
        ${view === 'comp' ? 'bg-action-btn text-white font-bold' : 'hover:bg-action-btn hover:text-white'}`}
          onClick={() => {
            setView('comp');
          }}
          type="button"
        >
          Components & Accessories
        </button>
      </div>

      {/* Specs & Comps View */}
      <OpacitySlideIn key={view} slideFrom={{ x: 0, y: 10 }} threshold={0}>
        {view === 'specs' ? (
          <ProductDetailSpecifications
            description={specification.description}
            list={specification.list}
          />
        ) : (
          <ProductDetailComponentsAndAccessories data={components} />
        )}
      </OpacitySlideIn>
    </div>
  );
};

export default ProductDetailInfo;
